var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C9984"
    },
    d: "M508.114,300.639L369.778,162.302L205.145,325.818l-61.487,72.404l113.761,113.761 C382.942,511.3,487.072,420.29,508.114,300.639z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "321.253,113.778 143.658,113.778 143.658,398.222 369.778,398.222 369.778,162.302 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6F3FF"
    },
    points: "369.778,162.302 321.253,113.778 237.037,113.778 237.037,398.222 369.778,398.222 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFDBE6"
    },
    points: "321.253,162.304 369.778,162.302 321.253,113.778 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#26BEBE"
    },
    cx: 237.037,
    cy: 215.143,
    r: 37.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1DA09C"
    },
    d: "M274.937,215.14c0-20.932-16.968-37.9-37.898-37.9v75.798 C257.969,253.038,274.937,236.07,274.937,215.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M158.868,334.76c0-43.172,34.997-78.169,78.169-78.169s78.169,34.997,78.169,78.169L158.868,334.76 L158.868,334.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M237.037,256.593v78.169h78.167C315.206,291.59,280.209,256.593,237.037,256.593z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD15D"
    },
    cx: 350.815,
    cy: 293.926,
    r: 63.104
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4A200"
    },
    d: "M350.815,369.778c-41.825,0-75.852-34.026-75.852-75.852s34.026-75.852,75.852-75.852 s75.852,34.026,75.852,75.852S392.64,369.778,350.815,369.778z M350.815,243.571c-27.765,0-50.355,22.59-50.355,50.355 c0,27.765,22.59,50.355,50.355,50.355c27.765,0,50.355-22.59,50.355-50.355C401.17,266.161,378.58,243.571,350.815,243.571z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.334,
    y: 265.24,
    style: {
      fill: "#F4A200"
    },
    width: 22.947,
    height: 57.372
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2);
export default __webpack_public_path__ + "static/media/profile-2.f91ade0164406f0106ae077f8baa02d2.svg";
export { ForwardRef as ReactComponent };